import { useEffect, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import close from "../../../assets/Icons/close.png";
import toothlensLogo from "../../../assets/illustrations/Toothlens Logo.jpeg";

const headingStyle = {
  color: "#2C3E50",
  fontFamily: "Poppins",
  fontWeight: "700",
  fontSize: "16px",
};

const thanksStyle = {
  color: "#2C3E50",
  fontFamily: "Poppins",
  fontWeight: "700",
};

const SubmitSuccess = () => {
    console.log("called here")
   const navigate = useNavigate();
   const [company, setCompany] = useState(() => localStorage.getItem("company") || "tl-star");
   const [cameraSide, setCameraSide] = useState(() => localStorage.getItem("cameraSide") || "front");
 const [uid, setUid] = useState(() => {
    const usertpiData = localStorage.getItem("usertpi");
    if (usertpiData) {
      try {
        const parsedData = JSON.parse(usertpiData);
        return parsedData.usertpi || "";
      } catch (error) {
        return "";
      }
    }
    return "";
  });

   const getNavigationPath = useCallback(() => {
    return `/review/${uid}/${company}/${cameraSide}`;
  }, []);

  const handleNavigation = useCallback(() => {
    const path = getNavigationPath();
    navigate(path); 
  }, [navigate, getNavigationPath]);

  
  useEffect(() => {
    const navigationPath = getNavigationPath();
        localStorage.clear();    
  }, [getNavigationPath]);

  return (
    <div className="h-screen bg-custom-gradient text-center flex flex-col justify-center items-center px-3 relative">
      
      <div className="absolute top-0 right-0 p-3">
        <button 
          type="button"
          onClick={handleNavigation}
          aria-label="Close"
          className="focus:outline-none hover:opacity-80 transition-opacity"
        >
          <img src={close} alt="Close" width="26" height="26" />
        </button>
      </div>

      <div className="flex justify-center"><img src={toothlensLogo} alt="ToothLens Logo" className="w-auto h-auto" /></div>
      
      <div className="flex justify-center">
        <div className="mt-8" style={headingStyle}>
          <p>Your photos and KYC details are submitted</p>
          <p>Our representative will get in touch with you</p>
        </div>
      </div>
      
      <p className="mt-5 text-3xl" style={thanksStyle}>Thanks</p>

    </div>
  );
};

export default SubmitSuccess;